import { List } from 'immutable';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import * as commonSelectors from 'containers/Common/selectors';
import * as Models from 'models';

export function useBrandColorsForRelation(
  relationId: string,
): Models.BrandColorsList {
  const flatColors = useSelector(commonSelectors.flatColorsByRelationId);

  return useMemo(
    (): Models.BrandColorsList => flatColors.get(relationId) ?? List([]),
    [relationId, flatColors],
  );
}
